import { Constants } from '../app.constant';

export const PAGES_SUB_MENU = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'general.menu.dashboard',
            icon: 'zmdi zmdi-view-dashboard',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'qmsdashboard',
        data: {
          menu: {
            title: 'QMS Dashboard',
            icon: 'zmdi zmdi-view-dashboard',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'dg-dashboard',
        data: {
          menu: {
            title: 'general.menu.dgDashboard',
            icon: 'zmdi zmdi-view-dashboard',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'demographic-dashboard',
        data: {
          menu: {
            title: 'general.menu.ruleEngine',
            icon: 'zmdi zmdi-view-dashboard',
            selected: false,
            expanded: false,
            order: 0
          }
        },
        children: [
          {
            path: 'demographic-campaign-rule-list',
            data: {
              menu: {
                title: 'general.menu.ruleEngine',
              }
            }
          }
          // ,
          // {
          //   path: 'demographic-dashboard',
          //   data: {
          //     menu: {
          //       title: 'Dashboard',
          //     }
          //   }
          // }
        ]
      },

      /*{
        path: 'notifications',
        data: { 
        menu: {
          title: 'Notifications',
          icon: 'zmdi zmdi-view-dashboard',
          selected: false,
          expanded: false,
          order: 0
        }
        }
      },*/
      {
        path: 'car-configurator',
        data: {
          menu: {
            title: 'TPA Dashboard',
            icon: 'zmdi zmdi-settings-square',
            selected: false,
            expanded: false,
            // order: 0
          }
        },
        children: []
      },
      {
        path: 'admin',
        data: {
          menu: {
            title: 'general.menu.user',
            icon: 'fa fa-user-circle-o',
            selected: false,
            expanded: false,
            order: 500,
          }
        },
        children: [
          {
            path: 'list-roles',
            data: {
              menu: {
                title: 'general.menu.role',
              }
            }
          },
          {
            path: 'list-user',
            data: {
              menu: {
                title: 'User Management',
              }
            }
          },
          {
            path: 'organization-settings',
            data: {
              menu: {
                title: 'Organization Setting',
              }
            }
          }/*,
          {
            path: 'app-setting',
            data: {
              menu: {
                title: 'App Setting',
              }
            }
          }*/
        ]
      },
      {
        path: 'cms',
        data: {
          menu: {
            title: 'general.menu.cms',
            icon: 'zmdi zmdi-view-quilt',
            selected: false,
            expanded: false,
            order: 500,
            // hidden: Constants.setCmsForPanasonicAdmin('userType', 'canPansonicAdminAccessCMS'),
          }
        },
        children: [
          {
            path: 'resolution-list',
            data: {
              menu: {
                title: 'general.menu.resolutionManagement',
              }
            }
          },
          {
            path: 'media-library',
            data: {
              menu: {
                title: 'Media Library',
              }
            }
          },
          {
            path: 'template',
            data: {
              menu: {
                title: 'general.menu.template',
              }
            }
          },
          {
            path: 'campaign-list',
            data: {
              menu: {
                title: 'Campaign',
              }
            }
          },
          {
            path: 'campaign-string-list',
            data: {
              menu: {
                title: 'Campaign String',
              }
            }
          },
          // {
          //   path: 'key-value-mapping',
          //   data: {
          //     menu: {
          //       title: 'Key Value Mapping',
          //     }
          //   }
          // }, 
          {
            path: 'planogram',
            data: {
              menu: {
                title: 'Planogram',
              }
            }
          },
          {
            path: 'planogram-v2',
            data: {
              menu: {
                title: 'Scheduler',
              }
            }
          }
        ]
      },
      {
        path: 'device',
        data: {
          menu: {
            title: 'general.menu.device_management',
            icon: 'zmdi zmdi-devices',
            selected: false,
            expanded: false,
            order: 500,
          }
        },
        children: [
          {
            path: 'register-device',
            data: {
              menu: {
                title: 'Register Device'
              }
            }
          },
          {
            path: 'device-info',
            data: {
              menu: {
                title: 'View All Device',
              }
            }
          },
          {
            path: 'device-group',
            data: {
              menu: {
                title: 'Media Player Groups',
              }
            }
          },
          {
            path: 'devices-config',
            data: {
              menu: {
                title: 'Device Setting',
              }
            }
          }


          /*,
          {
            path: 'alert',
            data: {
            menu: {
              title: 'Alert',
            }
            }
          },
          {
            path: 'content',
            data: {
            menu: {
              title: 'Content',
            }
            }
          }*/
        ]

      },

      {
        path: 'reports',
        data: {
          menu: {
            title: 'general.menu.report',
            icon: 'zmdi zmdi-chart',
            selected: false,
            expanded: false,
            order: 500,
          }
        },
        children: [
          {
            path: 'unschedule-media-player',
            data: {
              menu: {
                title: 'Unscheduled Media Player'
              }
            }
          },
          {
            path: 'user-activity',
            data: {
              menu: {
                title: 'User Activity'
              }
            }
          },
          {
            path: 'mp-summary',
            data: {
              menu: {
                title: 'MP Summary Report'
              }
            }
          },
          {
            path: 'media-player-onoff-log',
            data: {
              menu: {
                title: 'MP On-Off Log'
              }
            }
          },
          {
            path: 'media-player-onoff-percent',
            data: {
              menu: {
                title: 'MP On-Off Percent'
              }
            }
          },
          {
            path: 'content-previous-download',
            data: {
              menu: {
                title: 'Content Previous Download'
              }
            }
          },
          {
            path: 'content-current-download',
            data: {
              menu: {
                title: 'Content Current Download'
              }
            }
          },
          {
            path: 'content-playback',
            data: {
              menu: {
                title: 'Content Playback'
              }
            }
          },
          {
            path: 'planogram-reports',
            data: {
              menu: {
                title: 'Scheduled Planogram'
              }
            }
          },
          {
            path: 'scheduler-reports',
            data: {
              menu: {
                title: 'Scheduler Report'
              }
            }
          },
          {
            path: 'scheduler-summary-reports',
            data: {
              menu: {
                title: 'Scheduler Summary Report'
              }
            }
          },
          {
            path: 'statistics-report',
            data: {
              menu: {
                title: 'Statistics Report'
              }
            }
          },
          {
            path: 'panel-onoff',
            data: {
              menu: {
                title: 'Panel On-Off'
              }
            }
          },
          {
            path: 'panel-onoff-percent',
            data: {
              menu: {
                title: 'Panel On-Off Percent'
              }
            }
          },
          {
            path: 'bandwidth-per-customer',
            data: {
              menu: {
                title: 'Bandwidth Report'
              }
            }
          },
          {
            path: 'tpa-reports',
            data: {
              menu: {
                title: 'Tpa Versions'
              }
            }
          },
          {
            path: 'tpa-content-playback',
            data: {
              menu: {
                title: 'Tpa Content Playback'
              }
            }
          },
          {
            path: 'pdn-report',
            data: {
              menu: {
                title: 'SDN Report'
              }
            }
          }
          //  ,{
          //    path: 'customer-tiers-switch-report',
          //    data:{
          //      menu:{
          //       title:'Customers Tier Report'
          //      }
          //    }
          //  }
        ]
      },
      {
        path: 'fa-reports',
        data: {
          menu: {
            title: 'general.menu.faReport',
            icon: 'zmdi zmdi-chart',
            selected: false,
            expanded: false,
            order: 500,
          }
        },
        children: [
          {
            path: 'face-analytics-age-group',
            data: {
              menu: {
                title: 'DG Distribution by Age'
              }
            }
          },
          {
            path: 'face-analytics-gender',
            data: {
              menu: {
                title: 'DG Distribution by Gender'
              }
            }
          },
          {
            path: 'face-analytics-emotion',
            data: {
              menu: {
                title: 'DG Distribution by Emotion'
              }
            }
          },
          {
            path: 'emotion',
            data: {
              menu: {
                title: 'MP Emotion Comparison'
              }
            }
          }
          ,
          {
            path: 'dwell-time-age',
            data: {
              menu: {
                title: 'Dwell Time (By Age)'
              }
            }
          },
          {
            path: 'dwell-time-gender',
            data: {
              menu: {
                title: 'Dwell Time (By Gender)'
              }
            }
          },
          {
            path: 'export-files',
            data: {
              menu: {
                title: 'Export Data Files'
              }
            }
          },
          {
            path: 'fa-content-playback',
            data: {
              menu: {
                title: 'DG Campaign Playback'
              }
            }
          },
          {
            path: 'fa-content-playback-details',
            data: {
              menu: {
                title: 'DG Campaign Playback Details'
              }
            }
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/pages/pages.sub.menu.ts